import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavComponent } from './components/nav/nav.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { ActionDescriptorComponent } from './components/action-descriptor/action-descriptor.component';
import { SortByPipe } from './pipes/sort-by.pipe';
import { RequestIconPipe } from './pipes/request-icon.pipe';
import { ActionIconPipe } from './pipes/action-icon.pipe';
import { MsToSPipe } from './pipes/ms-to-s.pipe';
import { MatGridListModule } from '@angular/material/grid-list';
import { FormatFileSizePipe } from './pipes/format-file-size.pipe';
import { GalleryComponent } from './components/gallery/gallery.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ModalComponent } from './components/modal/modal.component';
import { PortalModule } from '@angular/cdk/portal';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { RawDataVisualisationComponent } from './components/raw-data-visualisation/raw-data-visualisation.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { StatusIconPipe } from './pipes/status-icon.pipe';
import { MaxValuePipe } from './pipes/max.pipe';
import { MatSliderModule } from '@angular/material/slider';
import { AlphabeticalSortingPipe } from './pipes/alphabetical-sorting.pipe';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SidebarLogsComponent } from './components/sidebar-logs/sidebar-logs.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CalculTotalRequestSizePipe } from './pipes/calcul-total-request-size.pipe';
import { RequestUrlPrettierPipe } from './pipes/request-url-prettier.pipe';
import { MatSortModule } from '@angular/material/sort';
import { StatusTranslatePipe } from './pipes/status-translate.pipe';
import { HasRoleDirective } from './directives/has-role.directive';
import { NgChartsModule } from 'ng2-charts';
import { DeviceIconPipe } from './pipes/device-icon.pipe';
import { DoughnutChartComponent } from './components/doughnut-chart/doughnut-chart.component';
import { LinesChartComponent } from './components/lines-chart/lines-chart.component';
import { IntroCardComponent } from './components/intro-card/intro-card.component';
import { SuccessRateCardComponent } from './components/success-rate-card/success-rate-card.component';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SuccessLineChartComponent } from './components/success-line-chart/success-line-chart.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { LinkUserToCompagnyModalComponent } from './components/link-user-to-compagny-modal/link-user-to-compagny-modal.component';
import { FormatTimePipe } from './pipes/format-time.pipe';
import { HighlightModule } from 'ngx-highlightjs';
import { TableBotsComponent } from './components/table-bots/table-bots.component';
import { TableAnalysesComponent } from './components/table-analyses/table-analyses.component';
import { TableSchedulesComponent } from './components/table-schedules/table-schedules.component';
import { TableSchedulesCtrlComponent } from './components/table-schedules-ctrl/table-schedules-ctrl.component';
import { TableBotsCtrlComponent } from './components/table-bots-ctrl/table-bots-ctrl.component';
import { TablePaginatorComponent } from './components/table-paginator/table-paginator.component';
import { TableAnalysesCtrlComponent } from './components/table-analyses-ctrl/table-analyses-ctrl.component';
import { TableUsersComponent } from './components/table-users/table-users.component';
import { TableUsersCtrlComponent } from './components/table-users-ctrl/table-users-ctrl.component';
import { TableInvitationsComponent } from './components/table-invitations/table-invitations.component';
import { FindIndexPipe } from './pipes/find-index.pipe';
import { TableCompanyComponent } from './components/table-company/table-company.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CompanySelectComponent } from './components/company-select/company-select.component';
import { WebVitalComponent } from './components/web-vital/web-vital.component';
import { AnalysisTriggerTypePipe } from './pipes/analysis-trigger-type.pipe';
import { DashboardUserComponent } from './components/dashboard-user/dashboard-user.component';
import { DashboardBotThumbComponent } from './components/dashboard-bot-thumb/dashboard-bot-thumb.component';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { YmlEditorComponent } from './components/yml-editor/yml-editor.component';
import { ImportFromRecorderDialogComponent } from './components/import-from-recorder-dialog/import-from-recorder-dialog.component';
import { BotFormActionComponent } from './components/bot-form-action/bot-form-action.component';
import { BotVisualizationTreeComponent } from './components/bot-visualization-tree/bot-visualization-tree.component';
import { MatListModule } from '@angular/material/list';
import { BotFormActionExpansionPanelComponent } from './components/bot-form-action-expansion-panel/bot-form-action-expansion-panel.component';
import { BotFormActionInputComponent } from './components/bot-form-action-input/bot-form-action-input.component';
import { BotFormActionInitComponent } from './components/bot-form-action-init/bot-form-action-init.component';
import { BotFormActionClickComponent } from './components/bot-form-action-click/bot-form-action-click.component';
import { BotFormActionScrollComponent } from './components/bot-form-action-scroll/bot-form-action-scroll.component';
import { BotFormActionWaitComponent } from './components/bot-form-action-wait/bot-form-action-wait.component';
import { BotFormActionSelectComponent } from './components/bot-form-action-select/bot-form-action-select.component';
import { BotFormActionFindTextComponent } from './components/bot-form-action-find-text/bot-form-action-find-text.component';
import { BotFormActionAssertClickableComponent } from './components/bot-form-action-assert-clickable/bot-form-action-assert-clickable.component';
import { BotFormActionEvaluateComponent } from './components/bot-form-action-evaluate/bot-form-action-evaluate.component';
import { BotFormActionUploadFileComponent } from './components/bot-form-action-upload-file/bot-form-action-upload-file.component';
import { OrderByPipe } from './pipes/order-by.pipe';
import { SecureImagePipe } from './pipes/secure-image.pipe';

@NgModule({
  imports: [
    HighlightModule,
    RouterModule,
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatCardModule,
    MatSlideToggleModule,
    PortalModule,
    MatTooltipModule,
    NgxJsonViewerModule,
    MatSelectModule,
    MatSliderModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatSortModule,
    NgChartsModule,
    MatMenuModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatChipsModule,
    DragDropModule,
    MatDialogModule,
    MonacoEditorModule,
    MatExpansionModule,
    MatListModule,
    NavComponent,
    ActionDescriptorComponent,
    SortByPipe,
    RequestIconPipe,
    ActionIconPipe,
    MsToSPipe,
    StatusIconPipe,
    FormatFileSizePipe,
    CalculTotalRequestSizePipe,
    RequestUrlPrettierPipe,
    StatusTranslatePipe,
    AnalysisTriggerTypePipe,
    GalleryComponent,
    ModalComponent,
    RawDataVisualisationComponent,
    MaxValuePipe,
    AlphabeticalSortingPipe,
    SidebarLogsComponent,
    HasRoleDirective,
    DeviceIconPipe,
    DoughnutChartComponent,
    LinesChartComponent,
    IntroCardComponent,
    SuccessRateCardComponent,
    SidebarComponent,
    SuccessLineChartComponent,
    BarChartComponent,
    LinkUserToCompagnyModalComponent,
    FormatTimePipe,
    TableBotsComponent,
    TableAnalysesComponent,
    TableSchedulesComponent,
    TableSchedulesCtrlComponent,
    TableBotsCtrlComponent,
    TablePaginatorComponent,
    TableAnalysesCtrlComponent,
    TableUsersComponent,
    TableUsersCtrlComponent,
    TableInvitationsComponent,
    FindIndexPipe,
    TableCompanyComponent,
    BreadcrumbComponent,
    CompanySelectComponent,
    WebVitalComponent,
    DashboardUserComponent,
    DashboardBotThumbComponent,
    YmlEditorComponent,
    ImportFromRecorderDialogComponent,
    BotFormActionComponent,
    BotVisualizationTreeComponent,
    BotFormActionExpansionPanelComponent,
    BotFormActionInputComponent,
    BotFormActionInitComponent,
    BotFormActionClickComponent,
    BotFormActionScrollComponent,
    BotFormActionWaitComponent,
    BotFormActionSelectComponent,
    BotFormActionFindTextComponent,
    BotFormActionAssertClickableComponent,
    BotFormActionEvaluateComponent,
    BotFormActionUploadFileComponent,
    OrderByPipe,
    SecureImagePipe,
  ],
  exports: [
    MatSidenavModule,
    NavComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatCardModule,
    MatDividerModule,
    MatProgressBarModule,
    MatButtonModule,
    MatSnackBarModule,
    MatTabsModule,
    MatTableModule,
    MatDialogModule,
    MatMenuModule,
    MatSelectModule,
    MatExpansionModule,
    MatTooltipModule,
    MatStepperModule,
    ActionDescriptorComponent,
    MatToolbarModule,
    SortByPipe,
    RequestIconPipe,
    ActionIconPipe,
    MsToSPipe,
    StatusIconPipe,
    CalculTotalRequestSizePipe,
    RequestUrlPrettierPipe,
    StatusTranslatePipe,
    MatGridListModule,
    FormatFileSizePipe,
    AnalysisTriggerTypePipe,
    DeviceIconPipe,
    GalleryComponent,
    MatSlideToggleModule,
    DragDropModule,
    PortalModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    RawDataVisualisationComponent,
    MatSliderModule,
    AlphabeticalSortingPipe,
    MatNativeDateModule,
    MatDatepickerModule,
    SidebarLogsComponent,
    MatButtonToggleModule,
    MatSortModule,
    HasRoleDirective,
    NgChartsModule,
    DoughnutChartComponent,
    LinesChartComponent,
    IntroCardComponent,
    SuccessRateCardComponent,
    SidebarComponent,
    ScrollingModule,
    SuccessLineChartComponent,
    BarChartComponent,
    FormatTimePipe,
    TableBotsComponent,
    TableAnalysesComponent,
    TableSchedulesComponent,
    TableSchedulesCtrlComponent,
    TableBotsCtrlComponent,
    TablePaginatorComponent,
    TableAnalysesCtrlComponent,
    TableUsersComponent,
    TableUsersCtrlComponent,
    TableInvitationsComponent,
    FindIndexPipe,
    TableCompanyComponent,
    BreadcrumbComponent,
    CompanySelectComponent,
    WebVitalComponent,
    DashboardUserComponent,
    DashboardBotThumbComponent,
    MonacoEditorModule,
    YmlEditorComponent,
    BotFormActionComponent,
    BotVisualizationTreeComponent,
    MatListModule,
    BotFormActionExpansionPanelComponent,
    BotFormActionInputComponent,
    BotFormActionInitComponent,
    BotFormActionClickComponent,
    BotFormActionScrollComponent,
    BotFormActionWaitComponent,
    BotFormActionSelectComponent,
    BotFormActionFindTextComponent,
    BotFormActionAssertClickableComponent,
    BotFormActionEvaluateComponent,
    BotFormActionUploadFileComponent,
    OrderByPipe,
    SecureImagePipe,
  ],
  providers: [HasRoleDirective],
})
export class SharedModule {}
